"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCustomerGroups = exports.filterCategories = exports.filterProjectAdministrators = exports.userSearchFilter = void 0;
/**
 * Filter for users firstname, lastname and email
 */
var userSearchFilter = function (user, searchString) {
    var haystack = "".concat((user.firstName || '').toLocaleLowerCase(), " ").concat((user.lastName || '').toLocaleLowerCase(), " ").concat(user.email);
    return haystack.indexOf(searchString) !== -1;
};
exports.userSearchFilter = userSearchFilter;
/**
 * Filter for project administrators (using userSearchFilter)
 */
var filterProjectAdministrators = function (userGroup, searchString) {
    if (searchString === '') {
        return userGroup;
    }
    if (userGroup && userGroup.members) {
        return __assign(__assign({}, userGroup), { members: userGroup.members.filter(function (user) {
                return (0, exports.userSearchFilter)(user, searchString);
            }) });
    }
};
exports.filterProjectAdministrators = filterProjectAdministrators;
/**
 * Filter for categories, userprofile names and members (using userSearchFilter)
 */
var filterCategories = function (mappedCategories, searchString) {
    if (searchString === '') {
        return mappedCategories;
    }
    return mappedCategories
        .map(function (_a) {
        var category = _a.category, groups = _a.groups;
        return ({
            category: category,
            groups: groups
                .map(function (group) {
                var categoryNameMatch = category.name.toLowerCase().indexOf(searchString) !== -1;
                var userProfileNameMatch = group.name.toLowerCase().indexOf(searchString) !== -1;
                var memberMatches = group.members.filter(function (member) {
                    return (0, exports.userSearchFilter)(member, searchString) ||
                        userProfileNameMatch ||
                        categoryNameMatch;
                });
                if ((memberMatches.length > 0 && !userProfileNameMatch) ||
                    userProfileNameMatch ||
                    categoryNameMatch) {
                    var c = __assign(__assign({}, category), { id: category.id, name: category.name, type: category.type, members: memberMatches.length > 0 ? memberMatches : category.members, uuid: category.uuid });
                    return c;
                }
                // Return non-matches with dummy id to filter with
                var d = __assign(__assign({}, category), { id: -1, name: category.name, type: category.type, members: category.members, uuid: category.uuid });
                return d;
            })
                .filter(function (category) { return category.id > 0; })
        });
    })
        .filter(function (_a) {
        var category = _a.category, groups = _a.groups;
        return category.name.toLowerCase().indexOf(searchString) !== -1 ||
            groups.length > 0;
    });
};
exports.filterCategories = filterCategories;
/**
 * Filter for user groups name property
 */
var filterCustomerGroups = function (userGroups, searchString) {
    if (searchString === '') {
        return userGroups; // sortElements(userGroups, 'name', 'asc')
    }
    return userGroups.filter(function (_a) {
        var name = _a.name;
        return name.toLowerCase().indexOf(searchString) !== -1;
    });
};
exports.filterCustomerGroups = filterCustomerGroups;
